<div class="execute-visit-wrapper" *ngIf="isReady">
  <mat-accordion *ngIf="visitMetaData">
    <ng-container *ngIf="visitMetaData.isMasar; else itimad">
      <mat-expansion-panel class="mat-elevation-z0 border-bottom" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ "forms.common.MasarCriteria.title" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-masar-criterions-tree
          [visitMetaData]="visitMetaData"
          [sessionId]="data.sessionId"
          [executeVisitType]="executeVisitType"
          [evaluatedSummaryType]="evaluatedSummaryType"
          [responseNotesDecision]="responseNotesDecision"
          [mistakeDisabled]="isMistakeDisabled"
          [categoriesCompliance]="categoriesCompliance"
          [disableEntityResponse]="disableEntityResponse"
          [disableAttachments]="disableAttachments"
          [hideMistake]="hideMistake"
          [viewOnly]="viewOnly"
        ></app-masar-criterions-tree>
      </mat-expansion-panel>
    </ng-container>

    <ng-template #itimad>
      <mat-expansion-panel class="mat-elevation-z0 border-bottom" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ "forms.common.Criteria.title" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-criterions-tree
          [visitMetaData]="visitMetaData"
          [sessionId]="data.sessionId"
          [executeVisitType]="executeVisitType"
          [categoriesCompliance]="categoriesCompliance"
          [viewOnly]="viewOnly"
        ></app-criterions-tree>
      </mat-expansion-panel>
    </ng-template>
  </mat-accordion>
</div>
